export interface ICalendarWeekInfoType {
  [key: number]: DayInWeekEnum;
}

export enum DayInWeekEnum {
  DAY_OFF = 'dayOff',
  WORK_DAY = 'workDay',
}
